import { styled } from 'goober';
import type { DefaultTheme } from 'goober';

interface AlertProps {
  messages: string[];
  onClose?: () => void;
  type: 'error' | 'info' | 'success' | 'warning';
}

const getAlertBackgroundColor = (props: {
  theme: DefaultTheme;
  type: AlertProps['type'];
}): string => {
  switch (props.type) {
    case 'error':
      return props.theme.colors.system.lowFit;
    case 'info':
      return props.theme.colors.spotlight.icon.blue.bg;
    case 'success':
      return props.theme.colors.blue.primaryA;
    case 'warning':
      return props.theme.colors.system.mediumFit;
  }
};

const getAlertTextColor = (props: {
  theme: DefaultTheme;
  type: AlertProps['type'];
}): string => {
  if (props.type === 'info') {
    return props.theme.colors.spotlight.icon.blue.color;
  }
  return props.theme.colors.basics.white;
};

export const Alert = ({
  type,
  messages,
  className,
}: {
  className?: string;
  messages: string[];
  type: AlertProps['type'];
}) => {
  return (
    <AlertContainer type={type} className={className}>
      {messages.map((message, index) => (
        <AlertMessage key={index}>
          {messages.length > 1 ? ' - ' : ''} {message}
        </AlertMessage>
      ))}
    </AlertContainer>
  );
};

const AlertContainer = styled('div')<Pick<AlertProps, 'type'>>`
  padding: 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: opacity 0.3s ease;
  background-color: ${props => getAlertBackgroundColor(props)};
  color: ${props => getAlertTextColor(props)};
`;

const AlertMessage = styled('span')`
  height: 20px;
`;
